let pageLoaderInst = null;

export default class PageLoader {

  constructor() {
    let _this = this;

    _this.$container = $('.js-pageloader');
    _this.blocks = [];
    pageLoaderInst = this;
  }

  static getInstance() {
    return (pageLoaderInst === null) ? new PageLoader() : pageLoaderInst;
  }

  show(nameBlock) {
    let _this = this;

    if (nameBlock && (_this.blocks.indexOf(nameBlock) < 0)) {
      _this.blocks.push(nameBlock);
    }
    _this.$container.addClass('_active');

    return _this;
  }

  hide(nameBlock) {
    let _this = this;

    if (!nameBlock) {
      _this.blocks = [];
    } else {
      let existIndex = _this.blocks.indexOf(nameBlock);
      if (existIndex > -1) {
        _this.blocks.splice(existIndex, 1);
      }
    }
    if (!_this.blocks.length) {
      _this.$container.removeClass('_active');
    }
    return _this;
  }

}


// WEBPACK FOOTER //
// ./resources/assets/js/src/Pageloader.js